import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    title: translate({ id: 'errorPage.invalidResetPasswordToken.title' }),
    description: translate({ id: 'errorPage.invalidResetPasswordToken.description' }),
    primaryAction: translate({ id: 'errorPage.invalidResetPasswordToken.primaryAction' }),
  }))

  return api
}
